class ModalManager {
  modals = [];
  isInitialized = false;
  isHandlingPop = false;
  closingFromHistory = false;
  ignoreNextPop = false;
  debug = false;
  init() {
    if (this.isInitialized) return;
    window.addEventListener('popstate', this.handlePopState);
    this.isInitialized = true;
    this.ignoreNextPop = false;
    this.isHandlingPop = false;
    if (this.debug) {
      console.log('[ModalManager] init');
    }
  }

  destroy() {
    window.removeEventListener('popstate', this.handlePopState);
    this.modals = [];
    this.isInitialized = false;
    this.closingFromHistory = false;
    this.ignoreNextPop = false;
    this.isHandlingPop = false;
    if (this.debug) {
      console.log('[ModalManager] destroy');
    }
  }

  handlePopState = (event) => {
    if (this.ignoreNextPop) {
      this.ignoreNextPop = false;
      return;
    }
    if (this.isHandlingPop) return;
    if (!this.modals.length) return;

    this.isHandlingPop = true;
    this.closingFromHistory = true;

    const modal = this.modals.pop();
    
    if (this.debug) {
      console.log('[ModalManager] close from history', modal?.id);
    }

    modal?.callback?.('back');

    queueMicrotask(() => {
      this.closingFromHistory = false;
      this.isHandlingPop = false;
    });
  };

  addModal(callback) {
    const id = crypto.randomUUID();

    this.modals.push({ id, callback });

    window.history.pushState(
      { __modal: true, modalId: id },
      ''
    );

    if (this.debug) {
      console.log('[ModalManager] add', id, 'stack:', this.modals.length);
    }

    return id;
  }

  closeModal(id) {
    if (!this.modals.length) return;

    const top = this.modals[this.modals.length - 1];
    if (top.id !== id) return;

    if (this.debug) {
     console.log('[ModalManager] close by ui', id);
    }

    this.modals.pop();
    this.ignoreNextPop = true;
    setTimeout(() => {
      window.history.back();
    }, 0);
  }

  count() {
    return this.modals.length;
  }
}

export const modalManager = new ModalManager();
